import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review.tasks');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { formatKstDateTime, SERVICE_TIME_ZONE } from "src/libs/portal/season/time";

@Component({
    selector: 'wiz-page-review-tasks',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review.tasks/view.scss */
:host {
  display: block;
  height: 100%;
}

.tasks-page {
  max-width: 1180px;
  margin: 0 auto;
  padding: 36px 32px 56px;
}

.tasks-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 24px;
}

.page-kicker {
  color: #656eae;
  font-size: 8px;
  font-weight: 850;
  letter-spacing: 0.14em;
}

.tasks-header h1 {
  margin: 7px 0 0;
  color: #292c46;
  font-size: 25px;
  letter-spacing: -0.035em;
}

.tasks-header p {
  margin: 8px 0 0;
  color: #85879a;
  font-size: 10px;
}

.review-date {
  padding-left: 22px;
  border-left: 1px solid #dfe0e8;
  text-align: right;
}

.review-date small,
.review-date strong {
  display: block;
}

.review-date small {
  color: #a1a2b1;
  font-size: 8px;
}

.review-date strong {
  margin-top: 5px;
  color: #55586d;
  font-size: 11px;
}

.review-summary {
  display: grid;
  margin-bottom: 16px;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.review-summary article {
  padding: 18px 20px;
  border: 1px solid #e0e0e8;
  border-radius: 12px;
  background: white;
}

.review-summary span,
.review-summary strong,
.review-summary small {
  display: block;
}

.review-summary span {
  color: #76798e;
  font-size: 9px;
  font-weight: 700;
}

.review-summary strong {
  margin-top: 10px;
  color: #292c46;
  font-size: 22px;
}

.review-summary small {
  margin-top: 4px;
  color: #aaaab7;
  font-size: 8px;
}

.tasks-panel {
  overflow: hidden;
  min-height: 330px;
  border: 1px solid #dedee7;
  border-radius: 14px;
  background: white;
}

.panel-toolbar {
  min-height: 58px;
  display: flex;
  align-items: center;
  padding: 0 18px;
  border-bottom: 1px solid #ececf1;
}

.filter-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
}

.filter-tabs button {
  display: inline-flex;
  align-items: center;
  padding: 7px 10px;
  border: 0;
  border-radius: 7px;
  color: #7c7e91;
  background: transparent;
  font-family: inherit;
  font-size: 9px;
  font-weight: 650;
  gap: 6px;
}

.filter-tabs button.is-active {
  color: #40477f;
  background: #eeeef6;
}

.filter-tabs span {
  display: inline-grid;
  min-width: 17px;
  height: 17px;
  place-items: center;
  border-radius: 5px;
  color: #8c8da0;
  background: rgba(255, 255, 255, 0.7);
  font-size: 7px;
}

.guide-button {
  margin-left: auto;
  padding: 7px 10px;
  border: 1px solid #dedee8;
  border-radius: 7px;
  color: #61647b;
  background: white;
  font-family: inherit;
  font-size: 9px;
  font-weight: 650;
}

.empty-state {
  min-height: 270px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 32px;
  text-align: center;
}

.empty-icon {
  display: grid;
  width: 54px;
  height: 54px;
  margin-bottom: 16px;
  place-items: center;
  border-radius: 17px;
  color: #6971ad;
  background: #efeff6;
}

.empty-icon svg {
  width: 25px;
  height: 25px;
  fill: currentColor;
}

.empty-state strong {
  color: #3e4058;
  font-size: 12px;
}

.empty-state p {
  margin: 8px 0 15px;
  color: #9293a3;
  font-size: 9px;
}

.empty-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 8px;
  border-radius: 99px;
  color: #6f718b;
  background: #f2f2f7;
  font-size: 8px;
  gap: 6px;
}

.empty-badge i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #8086bd;
}

.task-row {
  display: grid;
  width: 100%;
  min-height: 76px;
  align-items: center;
  padding: 13px 18px;
  border: 0;
  border-bottom: 1px solid #ececf1;
  color: inherit;
  background: #fff;
  grid-template-columns: minmax(260px, 1.4fr) 0.35fr 0.35fr 0.7fr auto;
  gap: 18px;
  text-align: left;
}

.task-row:hover {
  background: #f9f9fc;
}

.task-main {
  min-width: 0;
}

.task-main em {
  display: inline-block;
  padding: 3px 6px;
  border-radius: 5px;
  color: #535b98;
  background: #eceefa;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.task-main strong, .task-main small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.task-main strong {
  margin-top: 5px;
  color: #34374f;
  font-size: 11px;
}

.task-main small {
  margin-top: 3px;
  color: #999baa;
  font-size: 8px;
}

.task-row > div:not(.task-main) span {
  display: block;
  color: #9697a6;
  font-size: 8px;
}

.task-row > div:not(.task-main) strong {
  display: block;
  margin-top: 5px;
  color: #46495e;
  font-size: 10px;
}

.task-row strong.overdue {
  color: #b4514b;
}

.open-mark {
  color: #5e65a0;
  font-size: 8px;
  font-weight: 750;
  white-space: nowrap;
}

.detail-scrim {
  position: fixed;
  z-index: 40;
  inset: 0;
  background: rgba(22, 24, 48, 0.35);
}

.detail-panel {
  position: fixed;
  z-index: 41;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(760px, 96vw);
  overflow-y: auto;
  padding: 24px;
  background: #fff;
  box-shadow: -16px 0 42px rgba(24, 26, 54, 0.22);
}

.detail-panel > header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e5ed;
}

.detail-panel > header span, .review-item > header span, .qa-copy small, .evidence-copy > div span {
  color: #646bab;
  font-size: 8px;
  font-weight: 850;
  letter-spacing: 0.13em;
}

.detail-panel > header h2 {
  margin: 5px 0;
  color: #30334c;
  font-size: 22px;
}

.detail-panel > header p {
  margin: 0;
  color: #9798a7;
  font-size: 8px;
}

.detail-panel > header button {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  color: #55586c;
  background: #eeeef4;
  font-size: 22px;
}

.detail-loading {
  padding: 60px 20px;
  color: #74768c;
  text-align: center;
}

.scope-notice {
  margin: 14px 0;
  padding: 12px 14px;
  border-radius: 10px;
  color: #4f568b;
  background: #f0f1fa;
}

.scope-notice strong {
  font-size: 10px;
}

.scope-notice p {
  margin: 3px 0 0;
  font-size: 8px;
}

.scope-notice small {
  display: block;
  margin-top: 5px;
  color: #7278a5;
  font-size: 7px;
}

.review-item {
  margin-top: 12px;
  padding: 15px;
  border: 1px solid #e1e1ea;
  border-radius: 12px;
}

.review-item > header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.review-item > header code {
  overflow: hidden;
  max-width: 220px;
  color: #999aaa;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-copy {
  margin-top: 12px;
}

.qa-copy h3 {
  margin: 6px 0 14px;
  color: #32354e;
  font-size: 15px;
  line-height: 1.5;
}

.qa-copy > p {
  margin: 6px 0 0;
  color: #4a4d62;
  font-size: 10px;
  line-height: 1.7;
  white-space: pre-wrap;
}

.evidence-copy {
  margin-top: 14px;
  padding: 13px;
  border-radius: 9px;
  background: #f8f8fb;
}

.evidence-copy > div {
  display: flex;
  justify-content: space-between;
}

.evidence-copy > div em {
  color: #7175a2;
  font-size: 7px;
  font-style: normal;
}

.evidence-copy dl {
  margin: 10px 0;
  border-top: 1px solid #e5e5ec;
}

.evidence-copy dl div {
  display: grid;
  padding: 7px 0;
  border-bottom: 1px solid #e8e8ef;
  grid-template-columns: 70px 1fr;
  gap: 8px;
}

.evidence-copy dt {
  color: #9798a7;
  font-size: 8px;
}

.evidence-copy dd {
  margin: 0;
  color: #535569;
  font-size: 9px;
}

.evidence-copy > p {
  margin: 9px 0 0;
  color: #494c60;
  font-size: 10px;
  line-height: 1.7;
  white-space: pre-wrap;
}

.decision-history {
  display: flex;
  align-items: center;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid #dfe2ef;
  border-radius: 9px;
  background: #f6f7fb;
  gap: 10px;
}

.decision-history > div {
  display: flex;
  align-items: center;
  gap: 7px;
}

.decision-history span {
  color: #767ba4;
  font-size: 7px;
  font-weight: 850;
  letter-spacing: 0.1em;
}

.decision-history strong {
  color: #414978;
  font-size: 9px;
}

.decision-history p {
  margin: 0 0 0 auto;
  color: #898b9d;
  font-size: 7px;
}

.decision-history small {
  overflow: hidden;
  max-width: 210px;
  color: #85889d;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.decision-editor {
  margin-top: 12px;
  padding: 14px;
  border: 1px solid #dfe0e9;
  border-radius: 10px;
  background: #fff;
}

.decision-editor.is-locked {
  background: #f7f7f9;
}

.decision-editor > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.decision-editor > header div span,
.decision-editor > header div strong {
  display: block;
}

.decision-editor > header div span {
  color: #646bab;
  font-size: 7px;
  font-weight: 850;
  letter-spacing: 0.12em;
}

.decision-editor > header div strong {
  margin-top: 3px;
  color: #44475e;
  font-size: 10px;
}

.decision-editor > header > em {
  color: #9697a8;
  font-size: 7px;
  font-style: normal;
}

.decision-options {
  display: grid;
  margin-top: 11px;
  grid-template-columns: repeat(4, 1fr);
  gap: 7px;
}

.decision-options button {
  padding: 9px 6px;
  border: 1px solid #dddfe9;
  border-radius: 8px;
  color: #686a7c;
  background: #fff;
  font-family: inherit;
  font-size: 8px;
  font-weight: 750;
}

.decision-options button.selected {
  border-color: #5c66a3;
  color: #424b88;
  background: #eef0fa;
  box-shadow: inset 0 0 0 1px #5c66a3;
}

.decision-options button.selected[data-decision=REJECT] {
  border-color: #b76565;
  color: #9d4646;
  background: #fff1f1;
  box-shadow: inset 0 0 0 1px #b76565;
}

.decision-options button.selected[data-decision=HOLD] {
  border-color: #b38a4d;
  color: #8f6d38;
  background: #fff8e9;
  box-shadow: inset 0 0 0 1px #b38a4d;
}

.decision-options button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.reason-editor {
  margin-top: 12px;
  padding: 11px;
  border-radius: 8px;
  background: #faf7f1;
}

.reason-editor > span,
.revision-editor label > span,
.comment-editor > span {
  display: block;
  margin-bottom: 7px;
  color: #686b80;
  font-size: 8px;
  font-weight: 750;
}

.reason-editor span em,
.comment-editor span em {
  color: #a14f4f;
  font-size: 7px;
  font-style: normal;
}

.reason-editor > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.reason-editor button {
  padding: 5px 8px;
  border: 1px solid #ded9ce;
  border-radius: 99px;
  color: #777265;
  background: #fff;
  font-family: inherit;
  font-size: 7px;
}

.reason-editor button.selected {
  border-color: #8b7a5c;
  color: #66563d;
  background: #f1e8d7;
  font-weight: 750;
}

.revision-editor {
  display: grid;
  margin-top: 12px;
  grid-template-columns: 1fr;
  gap: 10px;
}

.revision-editor label,
.comment-editor {
  display: block;
}

.revision-editor textarea,
.comment-editor textarea {
  box-sizing: border-box;
  width: 100%;
  resize: vertical;
  padding: 10px;
  border: 1px solid #dfe0e9;
  border-radius: 8px;
  outline: 0;
  color: #424559;
  background: #fff;
  font-family: inherit;
  font-size: 9px;
  line-height: 1.6;
}

.revision-editor textarea:focus,
.comment-editor textarea:focus {
  border-color: #747db4;
  box-shadow: 0 0 0 2px rgba(90, 101, 165, 0.1);
}

.comment-editor {
  margin-top: 12px;
}

.annotation-editor {
  margin-top: 12px;
  padding: 11px;
  border: 1px solid #dfe2ef;
  border-radius: 8px;
  background: #f7f8fc;
}

.annotation-editor > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.annotation-editor > header span {
  color: #646bab;
  font-size: 7px;
  font-weight: 850;
  letter-spacing: 0.1em;
}

.annotation-editor > header small {
  color: #8d90a4;
  font-size: 7px;
}

.annotation-editor > div {
  display: grid;
  margin-top: 9px;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.annotation-editor label > span {
  display: block;
  margin-bottom: 5px;
  color: #666a80;
  font-size: 8px;
  font-weight: 750;
}

.annotation-editor label em {
  color: #a14f4f;
  font-size: 7px;
  font-style: normal;
}

.annotation-editor select {
  box-sizing: border-box;
  width: 100%;
  height: 34px;
  padding: 0 8px;
  border: 1px solid #d9dce8;
  border-radius: 7px;
  color: #44475b;
  background: #fff;
  font-family: inherit;
  font-size: 8px;
}

.decision-editor > footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 11px;
  gap: 10px;
}

.decision-editor > footer span {
  color: #9a6f6f;
  font-size: 7px;
}

.decision-editor > footer button {
  padding: 9px 12px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  background: #535b98;
  font-family: inherit;
  font-size: 8px;
  font-weight: 750;
}

.decision-editor > footer button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.detail-panel > footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}

.detail-panel > footer button {
  border: 0;
  border-radius: 8px;
  padding: 10px 13px;
  color: #fff;
  background: #535b98;
  font-size: 9px;
  font-weight: 750;
}

.review-help {
  display: grid;
  margin-top: 16px;
  padding: 20px;
  border: 1px solid #e0e0e8;
  border-radius: 13px;
  background: #fafafd;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.review-help > div {
  position: relative;
  padding-left: 32px;
}

.help-number {
  position: absolute;
  top: 0;
  left: 0;
  color: #858abd;
  font-size: 9px;
  font-weight: 850;
}

.review-help strong {
  display: block;
  color: #4b4d63;
  font-size: 10px;
}

.review-help p {
  margin: 6px 0 0;
  color: #9293a3;
  font-size: 8px;
  line-height: 1.55;
}

@media (max-width: 700px) {
  .tasks-page {
    padding: 26px 18px 42px;
  }
  .review-summary {
    grid-template-columns: 1fr;
  }
  .review-help {
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .task-row {
    grid-template-columns: 1fr 1fr;
  }
  .open-mark {
    display: none;
  }
  .panel-toolbar {
    align-items: flex-start;
    flex-direction: column;
    padding: 12px;
    gap: 10px;
  }
  .guide-button {
    margin-left: 0;
  }
  .decision-options {
    grid-template-columns: 1fr 1fr;
  }
  .decision-history {
    align-items: flex-start;
    flex-direction: column;
  }
  .annotation-editor > div {
    grid-template-columns: 1fr;
  }
  .decision-history p {
    margin-left: 0;
  }
}`],
})
export class PageReviewTasksComponent implements OnInit {
    public activeFilter: string = 'ASSIGNED';
    public loading: boolean = true;
    public detailLoading: boolean = false;
    public tasks: any[] = [];
    public selected: any = null;
    public todayLabel: string = '';
    public decisionForms: any = {};
    public savingCandidateId: string = '';

    public metrics: any[] = [
        { label: '배정', value: '0', description: '검수 시작 전' },
        { label: '진행 중', value: '0', description: '임시저장 포함' },
        { label: '완료', value: '0', description: '이번 주' }
    ];

    public filters: any[] = [
        { label: '배정', value: 'ASSIGNED', count: 0 },
        { label: '진행 중', value: 'IN_PROGRESS', count: 0 },
        { label: '완료', value: 'COMPLETED', count: 0 }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.todayLabel = new Intl.DateTimeFormat('ko-KR', {
            timeZone: SERVICE_TIME_ZONE,
            month: 'long',
            day: 'numeric',
            weekday: 'short'
        }).format(new Date());
        await this.load();
    }

    public currentDataset() {
        return this.service.auth.session.current_dataset || {};
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: '검수 처리 실패',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
    }

    public async load() {
        let dataset = this.currentDataset();
        if (!dataset.dataset_id) {
            this.loading = false;
            return;
        }
        this.loading = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/reviews/assignments/list', {
                dataset_id: dataset.dataset_id,
                status: this.activeFilter
            });
            if (result.code !== 200) {
                await this.showError(result.data && result.data.message ? result.data.message : '배정된 검수 작업을 불러오지 못했습니다.');
                return;
            }
            this.tasks = result.data.items || [];
            let summary = result.data.metrics || {};
            this.metrics = [
                { label: '배정', value: String(summary.assigned || 0), description: '검수 시작 전' },
                { label: '진행 중', value: String(summary.in_progress || 0), description: '판정 진행 중' },
                { label: '완료', value: String(summary.completed || 0), description: '제출 완료' }
            ];
            this.filters = [
                { label: '배정', value: 'ASSIGNED', count: Number(summary.assigned || 0) },
                { label: '진행 중', value: 'IN_PROGRESS', count: Number(summary.in_progress || 0) },
                { label: '완료', value: 'COMPLETED', count: Number(summary.completed || 0) }
            ];
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async setFilter(value: string) {
        this.activeFilter = value;
        this.selected = null;
        await this.load();
    }

    public async openDetail(task: any) {
        this.detailLoading = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/reviews/assignments/detail', {
                dataset_id: this.currentDataset().dataset_id,
                assignment_id: task.id
            });
            if (result.code !== 200) {
                await this.showError(result.data && result.data.message ? result.data.message : '검수 Batch 상세를 불러오지 못했습니다.');
                return;
            }
            this.selected = result.data;
            this.initializeDecisionForms();
        } finally {
            this.detailLoading = false;
            await this.service.render();
        }
    }

    public async closeDetail() {
        this.selected = null;
        this.decisionForms = {};
        await this.service.render();
    }

    private newDecisionKey(candidateId: string) {
        return 'decision-' + candidateId.substring(0, 8) + '-'
            + Date.now().toString(36) + '-'
            + Math.random().toString(36).substring(2, 10);
    }

    private initializeDecisionForms() {
        let forms: any = {};
        for (let item of this.selected.items || []) {
            let review = item.review || {};
            let revision = review.revision || {};
            let annotation = review.annotation || item.annotation_suggestion || {};
            forms[item.candidate_id] = {
                decision: review.decision || '',
                reason_codes: (review.reason_codes || []).slice(),
                comment: review.comment || '',
                question: revision.question || item.question,
                answer: revision.answer || item.answer,
                domain_code: annotation.domain_code || '',
                difficulty_code: annotation.difficulty_code || '',
                rfp_qa_type: annotation.rfp_qa_type || '',
                idempotency_key: this.newDecisionKey(item.candidate_id)
            };
        }
        this.decisionForms = forms;
    }

    public formFor(candidateId: string) {
        return this.decisionForms[candidateId] || {};
    }

    public async selectDecision(candidateId: string, decision: string) {
        let form = this.formFor(candidateId);
        form.decision = decision;
        if (decision !== 'HOLD' && decision !== 'REJECT') {
            form.reason_codes = [];
        }
        await this.service.render();
    }

    public reasonSelected(candidateId: string, reasonCode: string) {
        return (this.formFor(candidateId).reason_codes || []).indexOf(reasonCode) >= 0;
    }

    public async toggleReason(candidateId: string, reasonCode: string) {
        let form = this.formFor(candidateId);
        let reasons = form.reason_codes || [];
        let index = reasons.indexOf(reasonCode);
        if (index >= 0) reasons.splice(index, 1);
        else reasons.push(reasonCode);
        form.reason_codes = reasons.slice();
        await this.service.render();
    }

    public decisionLabel(value: string) {
        let options = this.selected && this.selected.decision_policy
            ? this.selected.decision_policy.decisions || []
            : [];
        let matched = options.find((option: any) => option.value === value);
        return matched ? matched.label : value;
    }

    public async submitDecision(item: any) {
        if (this.savingCandidateId) return;
        let form = this.formFor(item.candidate_id);
        if (!form.decision) {
            await this.showError('검수 판정을 선택해 주세요.');
            return;
        }
        if ((form.decision === 'HOLD' || form.decision === 'REJECT')
            && !(form.reason_codes || []).length) {
            await this.showError('보류와 반려에는 하나 이상의 사유가 필요합니다.');
            return;
        }
        if (form.decision === 'EDIT_APPROVE'
            && (!form.question.trim() || !form.answer.trim() || form.comment.trim().length < 2)) {
            await this.showError('수정 질문·답변과 2자 이상의 수정 사유를 입력해 주세요.');
            return;
        }
        if ((form.decision === 'APPROVE' || form.decision === 'EDIT_APPROVE')
            && (!form.domain_code || !form.difficulty_code || !form.rfp_qa_type)) {
            await this.showError('승인 항목의 한의학 분야·난이도·RFP QA 유형을 모두 확인해 주세요.');
            return;
        }

        this.savingCandidateId = item.candidate_id;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/reviews/decisions/submit', {
                dataset_id: this.currentDataset().dataset_id,
                assignment_id: this.selected.assignment.id,
                candidate_id: item.candidate_id,
                decision: form.decision,
                reason_codes: (form.reason_codes || []).join(','),
                comment: form.comment,
                question: form.decision === 'EDIT_APPROVE' ? form.question : '',
                answer: form.decision === 'EDIT_APPROVE' ? form.answer : '',
                domain_code: form.domain_code,
                difficulty_code: form.difficulty_code,
                rfp_qa_type: form.rfp_qa_type,
                idempotency_key: form.idempotency_key
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.showError(result.data && result.data.message ? result.data.message : '검수 판정을 저장하지 못했습니다.');
                return;
            }
            let assignment = { id: this.selected.assignment.id };
            await this.openDetail(assignment);
            await this.load();
            await this.service.modal.show({
                title: '판정 저장 완료',
                message: this.decisionLabel(result.data.decision.decision)
                    + ' 판정이 이력 ' + result.data.decision.decision_no + '번으로 저장되었습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
        } finally {
            this.savingCandidateId = '';
            await this.service.render();
        }
    }

    public statusLabel(value: string) {
        let labels: any = {
            ASSIGNED: '배정',
            IN_PROGRESS: '진행 중',
            COMPLETED: '완료'
        };
        return labels[value] || value;
    }

    public formatDate(value: string) {
        return formatKstDateTime(value, '기한 없음');
    }

    public async showGuide() {
        await this.service.modal.show({
            title: '검수 기준',
            message: 'Snapshot 근거를 기준으로 승인·수정 후 승인·보류·반려를 선택합니다. 보류와 반려는 사유가 필요하며, 수정안과 판정 변경은 원본을 덮지 않고 새 이력으로 저장됩니다.',
            cancel: false,
            action: '확인',
            actionBtn: 'success',
            status: 'success'
        });
        await this.service.render();
    }
}

export default PageReviewTasksComponent;